import Vue from "vue";
import InvestorReceivablePaymentsDetail from "src/components/templates/investor/payments/receivables/InvestorReceivablePaymentsDetail"
export default Vue.extend({
    template: `
        <div> 
          <InvestorReceivablePaymentsDetail :params='params'></InvestorReceivablePaymentsDetail>
        </div>
    `,
    data: function() {
        return {
            info: {}
        };
    },
    components: {
        InvestorReceivablePaymentsDetail
    },
    beforeMount() {},
    mounted() {},
    methods: {
        // called when the cell is refreshed
        refresh() {
            return false;
        },
    }
});